import React, { useState, useEffect } from "react";
import { LogOut, Menu, User } from "lucide-react";
import { signOut } from "firebase/auth";
import { auth, firestore } from "../../firebaseConfig";
import { doc, getDoc } from "firebase/firestore";

const CompanyHeader = ({ onToggleSidebar }) => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const userDoc = await getDoc(doc(firestore, "users", user.uid));
          if (userDoc.exists()) {
            setUserData(userDoc.data());
          }
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = "/login";
  };

  return (
    <header className="flex items-center justify-between bg-white shadow p-3 md:p-4 gap-2">
      <div className="flex items-center space-x-2 md:space-x-4 min-w-0">
        {/* Sidebar Toggle - visible on all screens */}
        <button
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar menu"
          className="p-2 rounded-lg bg-cyan-600 text-white hover:bg-cyan-700 focus:outline-none flex-shrink-0"
        >
          <Menu size={20} className="md:w-[22px] md:h-[22px]" />
        </button>
        <h1 className="text-base md:text-xl font-semibold text-cyan-700 truncate">Neuracraft Portal</h1>
      </div>

      <div className="flex items-center gap-2 md:gap-4 flex-shrink-0">
        {/* User Info - hidden on very small screens */}
        {userData && (
          <div className="hidden sm:flex items-center gap-2 px-2 md:px-4 py-1 md:py-2 bg-cyan-50 rounded-lg">
            <User size={16} className="text-cyan-700 md:w-[18px] md:h-[18px]" />
            <div className="text-xs md:text-sm">
              <p className="font-semibold text-cyan-900 truncate max-w-[100px] md:max-w-none">{userData.fullName}</p>
              <p className="text-xs text-cyan-600 hidden md:block">
                {userData.employeeRole || userData.accountType}
              </p>
            </div>
          </div>
        )}

        {/* Logout Button */}
        <button
          onClick={handleLogout}
          className="flex items-center space-x-1 md:space-x-2 bg-cyan-700 text-white px-2 md:px-4 py-2 rounded-lg hover:bg-cyan-800 text-sm md:text-base"
        >
          <LogOut size={16} className="md:w-[18px] md:h-[18px]" />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>
    </header>
  );
};

export default CompanyHeader;
